let StepChart = function (props) {
  let { startTs, series, stepCount, stepsPerMin } = props;
  let x = 40;
  let yMax = 135;
  let counts = [0, 0, 0, 0];
  let labels = ["12AM-6AM", "6AM-12PM", "12PM-6PM", "6PM-12AM"];

  series.forEach(function (d) {
    if (d.value > 0) {
      let n = Math.floor((d.ts - startTs) / (mc.math.MILLIS_PER_HOUR * 6));
      counts[n] += d.value;
    }
  });

  let rects = counts.map(function (n, i) {
    let h = mc.math.limit(yMax * (n / 3000), 5, yMax + 5);
    let tip = labels[i] + " - " + tx("count_steps", { _count: mc.format.number(n) });

    if (n > 0) {
      return (
        <rect
          key={i}
          x={x + (i * 50)}
          y={-h}
          width={20}
          height={h}
          data-tooltip={tip}/>
      );
    }

    return null;
  });

  return (
    <svg className="rc-step-chart" width="250" height="250">
      <image xlinkHref="./img/rc/steps.svg" width="250" height="250"/>
      <g className="rc-step-chart-data" transform="translate(0, 210)">
        {rects}
      </g>
      <g transform="translate(125, 30)">
        <text className="rc-step-chart-step-count" y="0" textAnchor="middle">
          {stepCount > 0 ? tx("count_steps", { _count: mc.format.number(stepCount) }) : "..."}
        </text>
        <text className="rc-step-chart-step-speed" y="20" textAnchor="middle">
          {stepsPerMin > 0 ? tx("count_steps_min", { _count: mc.format.number(stepsPerMin) }) : "..."}
        </text>
      </g>
    </svg>
  );
};

module.exports = StepChart;